import createMuiTheme from './CustomCreateTheme';

export const darkTheme = createMuiTheme({
    palette: {
        type: 'dark', // Switching the dark mode on is a single property value change.
        primary: {
            main: '#4f5064',
            // contrastText: '#000'
        },
        secondary: {
            main: '#EB5A4D',
            contrastText: '#000',
        },
        error: {
            main: '#eb5a4d',
        },
        warning: {
            main: '#FF2200',
        },
        success: {
            main: '#00C853',
        }
    },
    shape: {
        borderRadius: 10
    },
    typography: {
        "fontFamily": ['UniviaPro-Book'].join(','),
        "fontSize": 11,
        "fontWeightLight": "lighter",
        "fontWeightRegular": "normal",
        "fontWeightMedium": "bold"
    },
});


export const lightTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#4f5064',
            // contrastText: '#fff'
        },
        secondary: {
            main: '#B4B5BD',
            contrastText: '#fff',
        },
        error: {
            main: '#eb5a4d',
        },
        warning: {
            main: '#FFCF52',
        },
        success: {
            main: '#00C853',
        },
        action: {
            hoverOpacity: 0.15,             // affect to Outlined and Text buttons
            disabled: "rgba(0, 0, 0, 0.4)", // affect to button's text label
            disabledBackground: '#a7cce7',  // affect to button's background
        },
        text: {
            primary: "#4f5064",
            secondary: '#88898c',
        },
        grey: {
            50: "#F1F2F4",
            100: "#EDEDED",
            200: "#E6E6EB",
            300: "#B4B5BD",
            400: "#9e9e9e",
            500: "#88898C",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            A100: "#d5d5d5",
            A200: "#aaaaaa",
            A400: "#303030",
            A700: "#e6e6eb",
        },
        background: {
            paper: "#FFFFFF",
            default: "#ededed"
        }
    },
    shape: {
        borderRadius: 10
    },
    typography: {
        "fontFamily": ['UniviaPro-Book'].join(','),
        "fontSize": 11,
        "fontWeightLight": "lighter",
        "fontWeightRegular": "normal",
        "fontWeightMedium": "bold",
        h1: { fontSize: 35, fontWeight: 500, lineHeight: 1.2 },
        h2: { fontSize: 30, fontWeight: 500, lineHeight: 1.2 },
        h3: { fontSize: 25, fontWeight: 500, lineHeight: 1.2 },
        h4: { fontSize: 20, fontWeight: 500, lineHeight: 1.2 },
        h5: { fontSize: 18, fontWeight: "bold" },
        h6: { fontSize: 16, fontWeight: "bold" },
        subtitle1: { fontSize: 14 },
        subtitle2: { fontSize: 12, fontWeight: "bold", lineHeight: 'normal' },
        body1: { fontSize: 14, lineHeight: 1.65, letterSpacing: "0.5px" },
        body2: { fontSize: 12, lineHeight: 1.65, letterSpacing: "0.5px" },
        caption: { fontSize: 10 },
        overline: { fontSize: 8 }
    },
    overrides: {
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },

        // 'MuiToolbar' : {
        //     dense: {
        //         backgroundColor: "#FFFFFF",
        //     }
        // },
        // 'MuiDrawer': {
        //     docked: {
        //         height: "3000px",
        //         backgroundColor: "#4472AA",
        //     }
        // },
        // MuiInputBase: {
        //     input: {
        //         '&::placeholder': {
        //             color: '#88898c',
        //             opacity: 1
        //         }
        //     }
        // },

        'MuiButton': {
            contained: {
                boxShadow: 'none',
                '&$disabled': {
                    color: "#FFFFFF",
                    backgroundColor: "#F4AA32",
                    opacity: 0.5,
                    boxShadow: 'none'
                },
            },
            textPrimary: {
                color: "#f4aa32",
                '&:hover': {
                    backgroundColor: "rgba(244, 170, 50,0.2)",
                },
            },
            text: {
                '&$disabled': {
                    opacity: 0.5,
                },
                '&:hover': {
                    backgroundColor: "rgba(244, 170, 50,0.2)",
                },
            },
            containedPrimary: {
                boxShadow: 'none',
                backgroundColor: "#F4AA32",
                '&:hover': {
                    boxShadow: 'none',
                    backgroundColor: "#F4AA32",
                    opacity: 0.5
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: "#F4AA32" // make it darker
                }
            },
            containedSecondary: {
                boxShadow: 'none',
                backgroundColor: "#fed061",
                '&:hover': {
                    boxShadow: 'none',
                    backgroundColor: "#fed061",
                    opacity: 0.5
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: "#fed061" // make it darker
                }
            },
            'startIcon': {
                transform: "scale(0.8)",
                marginRight: "0px"
            },
            'endIcon': {
                transform: "scale(0.8)",
                marginLeft: "0px"
            }
        },
        MuiPickersToolbar: {
            toolbar: {
                height: '70px',
                backgroundColor: '#f4aa32'
            },
        },
        MuiPickersToolbarText: {
            toolbarTxt: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                color: 'rgba(255, 255, 255, 0.7)',
            },
            toolbarBtnSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '18px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
                color: '#ffffff',

            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: '#f4aa32',
                color: '#ffffff'
            },
        },
        MuiTypography: {
            alignCenter: {
                fontFamily: 'UniviaPro',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.2,
                letterSpacing: 'normal',
                color: '#4f5064',
            }, colorInherit: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                // color: '#4f5064',
            }
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
                color: '#88898c',
            }
        },
        MuiPickersClockNumber: {
            clockNumber: {
                fontFamily: 'UniviaPro',
                fontSize: '11px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.25,
                letterSpacing: '0.11px',
            }
        },
      
        MuiPickersYear: {
            yearSelected: {
                fontFamily: 'UniviaPro',
                fontSize: '18px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
            },
            root: {
                fontFamily: 'UniviaPro',
                fontSize: '14px',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 2.83,
                letterSpacing: '0.25px',
            }
        }
    },
    menu: {
        color: {
            subItem: '#4f5064',
            item: '#2b3648',
            selected: '#f4aa32'
        }
    },
    squareButon: {
        bgColor: '#f4aa32',
        content: 'white'
    },
    tab: {
        selectedColor: '#F4AA32'
    }
});

